import { render, staticRenderFns } from "./UserTables.vue?vue&type=template&id=5a682de4"
import script from "./UserTables.vue?vue&type=script&lang=js"
export * from "./UserTables.vue?vue&type=script&lang=js"
import style0 from "./UserTables.vue?vue&type=style&index=0&id=5a682de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports